<template>
    <div>
        <button
            class="btn btn--small btn--secondary min-w-[80px]"
            @click="clicked"
        > 
            <icon-edit v-if="selected" class="icon"/>
            <icon-finger v-else class="icon"/>
            <span class="leading-none">{{ buttonText }}</span>
        </button>
    </div>
</template>

<script>
import IconFinger from "../Icons/IconFinger.vue";
import IconEdit from "../Icons/IconEdit.vue";
 
export default {
    name: "SelectButton",
    components: {IconEdit, IconFinger},
    props: {
        selected: {},
        clicked: {
            default: function () {}
        }
    },
    computed: {
        buttonText() {
            return this.selected ? 'Edit' : 'Select'
        }
    }
}
</script>

<style lang="scss" scoped>
.icon {
    @apply w-3.5 h-3.5;
}

</style>